export default __webpack_public_path__ + "741e07577ea91758915b290c6b8b370d.png";